import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { MailSablonuService } from '../../../services/MailSablonuService';
import { GetMailSablonuListRequest, initialGetMailSablonuListRequest } from '../../../models/request/mailSablonu/GetMailSablonuListRequest';
import { GetMailSablonuListResponse, GetMailSablonuListResponseData, GetMailSablonuListResponseItem, initialGetMailSablonuListResponseData, MailSablonuMesajResponse } from '../../../models/response/mailSablonu/MailSablonuResponses';
import MailSablonuListFilters from './Components/MailSablonuListFilters';

const MailSablonuList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const pageName = "Ayarlar > Mail Şablonları"
    const pageVersion = "1";
    const [data, setData] = useState<GetMailSablonuListResponseData>(initialGetMailSablonuListResponseData);
    const [filter, setFilter] = useState<GetMailSablonuListRequest>(initialGetMailSablonuListRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Ad', name: 'ad', order: 0, isVisible: true },
            { title: 'Konu', name: 'konu', order: 0, isVisible: true },
            { title: 'Güncelleme Tarihi', name: 'updatedDate', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const updateMailSablonu = async (_id: string | undefined = undefined) => {
        navigate('/mailsablonu/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].mailSablonuId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetMailSablonuListRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetMailSablonuListResponse = await MailSablonuService.getMailSablonuList(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            // Sayfalı yanıt beklenir; sunucu düz dizi dönerse tek sayfa olarak gösterilir.
            if (Array.isArray(response.data))
                setData({ items: response.data, totalRecordCount: response.data.length });
            else
                setData(response.data ?? initialGetMailSablonuListResponseData);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.mailSablonuId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.length == data.items.filter(x => x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: MailSablonuMesajResponse = await MailSablonuService.exportMailSablonuList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.mailSablonuId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Kolon adları backend'deki sıralama eşlemesiyle aynı olmalı.
    const sortableColumns = ['ad', 'konu', 'updatedDate', 'updatedUser'];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        ad: { type: 'text' },
        konu: { type: 'text' },
        updatedDate: { type: 'date' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetMailSablonuListResponseItem, column: string, className: string | undefined) => {
        var item2: any = item;
        return <td className={className} onClick={() => setItemSelected(item.mailSablonuId)} onDoubleClick={() => updateMailSablonu(item.mailSablonuId)}>{item2[column]}</td>;
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <MailSablonuListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    onSearchSubmit={onSearchSubmit}
                    updateFunction={updateMailSablonu}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.length > 0 && data.items.filter(x => x.isSelected).length == data.items.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.mailSablonuId)} className='form-check-input' type='checkbox' checked={!!item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default MailSablonuList;
